import React from "react";
import { Grid2, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BookingScheduleInterface } from "../../features/Booking-Form/typings/booking.types";
import { ScheduleEventContentIcon } from "./schedule-event-content-icon.component";
import { resolveScheduleVisitorCalendarLabel } from "./functions/schedule-visitor-display-name.function";
import { Colleague } from "../../features/Connections/types/Colleague.type";
import { namePerType } from "../FacilityManager/Components/Toolbars/InfoSidebar/AssignBox/AssignBox";
import { BookingType } from "../../features/Booking-Form/typings/booking-inputs";

type P = {
  schedule: BookingScheduleInterface;
  userId: string;
  bookingUser?: Colleague;
  /** When false (resource calendar), hide conference visitor mail link. */
  showConferenceVisitorContactLink?: boolean;
};

export const ScheduleEventBookingTypeContents: React.FC<P> = ({
  schedule,
  userId,
  bookingUser,
  showConferenceVisitorContactLink = true
}) => {
  const { t } = useTranslation();

  const bookingNamePerType = t(namePerType(schedule.bookingType, t));
  const bookingInventoryName =
    (schedule.bookingInventory?.name === "Mobile Working"
      ? t("Mobile Working")
      : schedule.bookingInventory?.name) || bookingNamePerType;
  const bookingName =
    schedule.bookingType === BookingType.VEHICLE && schedule.vehicleInfo
      ? schedule.vehicleInfo.name
      : bookingInventoryName;

  const visitorCalendarLabel = resolveScheduleVisitorCalendarLabel(schedule);
  const showVisitorName = visitorCalendarLabel !== null;

  return (
    <Grid2
      container
      alignItems={"center"}
      data-testid="schedule-popover-bookingType-content-parent"
      flexWrap={"nowrap"}
      sx={{ mb: 1 }}
    >
      {/* booking type icon */}
      <Grid2
        sx={{
          marginRight: "0.6rem",
          marginTop: schedule.bookingType === BookingType.CONFERENCEZONE ? "0.6rem" : "0.4rem"
        }}
        data-testid="schedule-popover-bookingType-content"
      >
        <ScheduleEventContentIcon
          schedule={schedule}
          userId={userId}
          iconSize={30}
          bookingUser={bookingUser}
          showConferenceVisitorContactLink={showConferenceVisitorContactLink}
        />
      </Grid2>

      {/* booking name or visitor name */}
      {showVisitorName ? (
        <Grid2 data-testid="schedule-popover-booking-visitor-name">
          <Typography sx={{ fontWeight: "bold" }}>{visitorCalendarLabel}</Typography>
        </Grid2>
      ) : (
        <Grid2 data-testid="schedule-popover-booking-inven-name">
          <Typography sx={{ fontWeight: "bold" }}>{bookingName}</Typography>
        </Grid2>
      )}
    </Grid2>
  );
};
